import React, {Component} from 'react';
import './Outro.css';
import { getText, getLanguage } from './AllTexts.jsx';

class AckBox extends Component {
    render() {
        let image = [];
        let textclass = "";

        let ack1 = [];
        let ack2 = [];

        if (this.props.image) {
            image = <a href={this.props.url} target="_blank"><img style={{width: this.props.width || ""}} src={this.props.image} /></a>;
        } else {
            textclass = "large";
        }

        ack1 = <div className="ack1">{image}<a href={this.props.url} target="_blank" className={textclass}>{this.props.title}</a><div className="acktext">{this.props.text}</div></div>;
        if (this.props.title2) {
             ack2 = <div className="ack2"><a href={this.props.url2} target="_blank" className={textclass}>{this.props.title2}</a><div className="acktext">{this.props.text2}</div></div>;
        }

        return <div className="ackbox">
            {ack1}
            {ack2}
        </div>;
    }
}

export default class Outro extends Component {
    render() {
        return <div className="Component" id="outro">
        <div className="title">Conclusions</div>
        {getText('outro-intro')}
        <div className="title">{getText('acknowledgements-title')}</div>
        <div className="text">
            {getText('acknowledgements-text')}
            <div className="ack">
                 <AckBox
                    title="Max Planck Institute for the Study of Religious and Ethnic Diversity"
                    url="http://www.mmg.mpg.de/"
                    image="images/logos/mmg.png"
                 />
                 <AckBox
                    title="Stamen Design"
                    url="http://stamen.com"
                    image="images/logos/stamen.png"
                    text="Visualization development and web design"
                 />
                 <AckBox
                    title="Immersive Visualisation Platform, Monash University"
                    url="https://www.monash.edu/researchinfrastructure/mivp"
                    image="images/logos/monash.jpg"
                />
                <AckBox
                    title="Statistics New Zealand"
                    text="Special thanks to Robert Didham"
                    image="images/logos/statsnz.svg"
                    url="https://www.stats.govt.nz/"
                />
                <AckBox
                    title="Australian Bureau of Statistics"
                    text="Special thanks to Robert Didham"
                    image="images/logos/ausstat.png"
                    width={180}
                    url="http://www.abs.gov.au/"
                />
                <AckBox
                    title="Statistics Canada"
                    text=""
                    image="images/logos/statscanada.png"
                    url="https://www.statcan.gc.ca/eng/start"
                />
                <AckBox
                    title="Immigration, Refugees, and Citizenship Canada"
                    text=""
                    image="images/logos/ircc.png"
                    url="https://www.canada.ca/en/immigration-refugees-citizenship.html"
                />
                <AckBox
                    title="Aateka Shashank"
                    text="Research assistant for the entire project"
                    url="https://www.sfu.ca/geography/people/profiles/aateka-shashank.html"
                    title2="Meghan Kelly"
                    text2="Visualization Consultant"
                    url2="http://meghankelly-cartography.github.io/DesignChallenge.html"
                />
                <AckBox
                    title="Ernest Healy"
                    text="Research assistant for Australia/Sydney"
                    url="http://tapri.org.au/?page_id=8"
                />
            </div>
        </div>
        <div className="footer">
				<div className="privacy">
                  <iframe
                    style={{border: 0, height: 120 + 'px', width: 100 + '%'}}
                    src={`//matomo.gwdg.de/index.php?module=CoreAdminHome&action=optOut&language=${getLanguage()}`}>
                  </iframe>
				</div>
               <div className="copyright">
                    <a href="http://www.mmg.mpg.de/" target="_blank">© {new Date().getFullYear()} Max Planck Institute for the Study of Religious and Ethnic Diversity</a>
               </div>
               <div className="footer-menu">
                    <div className="footer-button"><a href="http://www.mmg.mpg.de/legal-notice/" target="_blank">Legal Notice</a></div>
                    <div className="footer-button"><a href="http://www.mmg.mpg.de/privacy-policy/" target="_blank">Privacy Policy</a></div>
               </div>
        </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/Outro.jsx